function IconGlobalPresence() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="22" stroke="#F5B400" strokeWidth="3" />
      <path d="M10 32H54" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C40 18 40 46 32 54" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 10C24 18 24 46 32 54" stroke="#F5B400" strokeWidth="3" />
      <path d="M44 18L52 12" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
      <path d="M48 12H52V16" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconPartnerships() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="22" cy="20" r="5" stroke="#F5B400" strokeWidth="3" />
      <circle cx="42" cy="20" r="5" stroke="#F5B400" strokeWidth="3" />
      <path d="M16 40C16 32 20 28 22 28C24 28 28 32 28 40" stroke="#F5B400" strokeWidth="3" />
      <path d="M36 40C36 32 40 28 42 28C44 28 48 32 48 40" stroke="#F5B400" strokeWidth="3" />
      <path d="M22 42L28 48C30 50 34 50 36 48L42 42" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
      <path d="M26 38L32 44L38 38" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconEfficiency() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="10" stroke="#F5B400" strokeWidth="3" />
      <path d="M32 14V22M32 42V50M14 32H22M42 32H50" stroke="#F5B400" strokeWidth="3" />
      <path d="M18 18L24 24M40 40L46 46M46 18L40 24M18 46L24 40" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

function IconQuality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M32 10L50 18V30C50 42 42 50 32 54C22 50 14 42 14 30V18L32 10Z"
        stroke="#F5B400"
        strokeWidth="3"
      />
      <path d="M24 32L30 38L42 24" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconSustainability() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M14 48H50" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
      <path d="M20 48V36C20 28 26 22 32 22C38 22 44 28 44 36V48" stroke="#F5B400" strokeWidth="3" />
      <path
        d="M32 22C32 14 28 10 24 12C20 14 18 18 20 24C22 30 32 22 32 22Z"
        stroke="#F5B400"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M32 30V18" stroke="#F5B400" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconCustomerValue() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="22" cy="22" r="5" stroke="#F5B400" strokeWidth="3" />
      <circle cx="42" cy="22" r="5" stroke="#F5B400" strokeWidth="3" />
      <circle cx="32" cy="14" r="4" stroke="#F5B400" strokeWidth="3" />
      <path d="M14 46C14 38 18 34 22 34C26 34 30 38 30 46" stroke="#F5B400" strokeWidth="3" />
      <path d="M34 46C34 38 38 34 42 34C46 34 50 38 50 46" stroke="#F5B400" strokeWidth="3" />
    </svg>
  )
}

export const achievementsFutureGoalsIcons = {
  'global-presence': IconGlobalPresence,
  partnerships: IconPartnerships,
  efficiency: IconEfficiency,
  quality: IconQuality,
  sustainability: IconSustainability,
  'customer-value': IconCustomerValue,
}
